import config from '../config.json';

export function currencyFormat(number, locale = config.locale, currency = config.currency) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number);
}